module.exports = __webpack_public_path__ + "static/media/tarjetas.36d86b46.svg";